define('views/modules/calendar/animated-session/exercise/edit/exercise-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    'services/events/animated-session-events',
    'services/toastr-service',
    // views
    'views/parts/menu/menu-save-action',
    'views/modules/calendar/animated-session/exercise/edit/exercise-edit-block',
    'views/modules/calendar/animated-session/exercise/history/exercise-history',
    // models & collections
    'models/parts/menu/done-button',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/edit/exercise-edit-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    AnimationEvents,
    ToastrService,
    // views
    VMenuSaveAction,
    VExerciseEditBlock,
    VExerciseHistory,
    // models & collections
    MDoneButton,
    // templates
    TExerciseEditContent
) {

    var VExerciseEditContent = Backbone.View.extend({
        template: TExerciseEditContent,

        regions: {
            root: ".exercise-edit-content",
            menu: ".menu-actions",
            exercise: ".exercise-edit-block",
            history: ".exercise-history"
        },

        initialize: function(opt) {
            this.options = opt || {};

            _.extend(this, {
                session: opt.session,
                item: opt.item
            });

            this.inSaveAndNextMode = false;

            var model = this.model,
                collection = this.collection = model.getCollection(), // phases OR weeks
                view = this.view = {
                    menu: new VMenuSaveAction({
                        context: this,
                        onClick: this.onActionClick,
                        onSave: this.onSaveClick,
                        collection: new Backbone.Collection([
                            new MDoneButton({
                                title: i18n.t('messages:tooltip-mark-as-done'),
                                callback: this.onDoneClick,
                                context: this
                            }),
                            //{ icon: 'fa fa-arrow-right icon-right', content: "Save and Next", itemClass: "pull-right", callback: this.onSaveAndNextClick }
                        ]),
                        tooltip: {
                            container: this.regions.root,
                        },
                    }),
                    exercise: new VExerciseEditBlock({
                        model: model,
                        item: this.item,
                    }),
                    history: new VExerciseHistory({
                        model: model,
                        item: this.item,
                        profile: opt.profile,
                        collection: collection,
                        session: this.session
                    })
                };

            this.collectionCopy = this.collection.toJSON({ blacklist: true });
            this.modelCopy = this.model.clone();

            this.listenTo(AnimationEvents, "exercises:saveRepsOrLoads", this.onWeightSaveClick);

            this.listenTo(model, {
                'change change:sets': this.onModelChange,
                'model:reset': this.onModelReset
            });

            this.listenTo(AnimationEvents, "exercise:editBegin", this.onEditBegin);
        },

        onEditBegin: function(model) {
          this.inSaveAndNextMode = false;
        },

        render: function() {
            this.refreshModels();

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.manageNextButtonDisplay();

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.exercise, zone.$exercise);

            if (this.model.isWeight()) {
                this.assign(view.history, zone.$history);
            }

            this.toggleDoneClass()
                .toggleSaveButton();

            return this;
        },

        //Don't know why, but the model do not change between exercises display
        refreshModels: function() {
          this.options.model = this.model;
          this.view.exercise.model = this.model;
          this.view.history.model = this.model;
          this.view.history.options.model = this.model;
        },

        manageNextButtonDisplay: function() {
            //try to find the button
            var menuNext = this.view.menu.collection.find(function(model) { return model.get("callback").name === "onSaveAndNextClick"; });
            //If there's a next model to display, add the button if not already present
            if (this.model.get("next")) {
                if (!menuNext) {
                     this.view.menu.collection.add({ icon: 'fa fa-arrow-right icon-right',
                                                     content: i18n.t("calendar:Save and next"),
                                                     itemClass: "pull-right",
                                                     callback: this.onSaveAndNextClick
                                                   }, {
                                                        at: this.view.menu.collection.length - 1
                                                      });
                }
            } else {
                //If the button is there and there's no next model to display, remove it
                if (menuNext) {
                    this.view.menu.collection.remove(menuNext);
                }
            }
        },

        getModelCopy: function() {
            return this.modelCopy;
        },

        hasCollectionChanged: function() {
            return !this.collection.equals(this.collectionCopy);
        },

        isDirty: function() {
            var model = this.model;
            if (model.isWeight()) {
                if (this.model.get('repsType') !== this.modelCopy.get('repsType') || this.hasCollectionChanged()) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return this.modelCopy.changedAttributes(this.model.omit('phases'));
            }
        },

        toggleSaveButton: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        toggleDoneClass: function(value) {
            this.zone.$menu.find('.btn-action-done').toggleClass('completed level-0', value || this.model.getWeekDone(this.item.getWeek()));
            return this;
        },

        triggerSave: function(shouldClose) {
            if (this.inSaveAndNextMode) {
                this.markAsDone();
                //push modification to the current session (see session-week-content -> onSaveAndNext() function)
                AnimationEvents.saveAndNext(this.model, false);
            } else {
                if (shouldClose) {
                    this.trigger('form:success', this.model, shouldClose);
                    this.view.menu.toggleSaveButton(shouldClose);
                } else {
                    this.trigger('form:success', this.model);
                }
            }
        },

        ////////////
        // events //
        ////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        markAsDone: function() {
          if (this.item.hasPassed()) {
              if (this.model.isWeight()) {
                  var week = this.model.getWeek(this.item.getWeek());
                  week.toggleDone(true);
              } else {
                  var weekIndex = this.item.getWeek();
                  this.model.setCardioWeekDone(weekIndex);
              }
          }
        },

        onSaveAndNextClick: function() {
            this.inSaveAndNextMode = true;
            //Set as done if date is passed
            this.markAsDone();
            //push modification to the current session (see session-week-content -> onSaveAndNext() function)
            AnimationEvents.saveAndNext(this.model, false);
            //move the ihm to the next exercice
            var nextModel = this.model.get("next");
            this.model = nextModel;
            this.options.model = nextModel;
            this.onModelReset(nextModel);
            this.view.exercise.model = nextModel;
            this.view.history.model = nextModel;
            this.view.history.options.model = nextModel;
            this.listenTo(this.model, {
                'change change:sets': this.onModelChange,
                'model:reset': this.onModelReset
            });
            this.render();
        },

        onWeightSaveClick: function() {
            this.triggerSave(true);
        },

        onDoneClick: function(silent) {
            var model = this.model;

            if (!this.item.hasPassed()) {
                ToastrService.error('calendar:cannot-mark-future-items-as-done');
                return;
            }

            if (model.isWeight()) {
                var week = model.getWeek(this.item.getWeek());
                week.toggleDone(!week.isDone());

                if (!silent)
                    model.trigger('change:done', week.isDone());

            } else {
                var weekIndex = this.item.getWeek();
                model.setCardioWeekDone(weekIndex);
            }

            this.toggleDoneClass()
                .onModelChange();
        },

        onModelReset: function(model) {
            var COLLECTION_CONSTRUCTOR = _.result(model, 'getCollectionConstructor', false),
                collection = this.collection = new COLLECTION_CONSTRUCTOR(model.getCollection().models);
            this.collectionCopy = collection.toJSON({ blacklist: true });
            this.modelCopy = model.clone();

            this.view.history.fetchHistory(this.model);
        },

        onModelChange: function() {
            this.toggleSaveButton();
        },

        onSaveClick: function() {
            this.markAsDone();
            if (this.inSaveAndNextMode) {
                //push modification to the current session (see session-week-content -> onSaveAndNext() function)
                AnimationEvents.saveAndNext(this.model, true);
            } else {
                this.trigger('form:success', this.model);
                this.trigger('exercise:done', this.model);
            }
        },

    });

    return VExerciseEditContent;

});

